import { isArray } from 'lodash';

export const asString = (landing: string | string[] | undefined | null) =>
  (isArray(landing) ? landing[0] : landing) || '';
